@if (tags(); as tags) {
  <div>
    @for (tag of tags; track tag) {
      <span class="tag tag-{{ tag.color }} mb-1 me-1">{{ tag.label | translate }}</span>
    }
    @if (tags.length === 0) {
      <span> - </span>
    }
  </div>
}
